<template>
  <label class="switch">
    <input type="checkbox" class="primary" :checked="checked" />
    <span class="slider round"></span>
  </label>
</template>

<script>
export default {
  name: 'switchButton',
  props: {
    checked: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 25px;
  // margin-top: -0px;
  input {
    display: none;
  }
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: $gray;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: '';
  height: 18px;
  width: 18px;
  left: 4px;
  bottom: 4px;
  background-color: $white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input.primary:checked + .slider {
  background-color: $primary;
}
input:focus + .slider {
  box-shadow: 0 0 1px $primary;
}
input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/atoms/switch/index.vue